import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { heroSlides } from '@/mocks/movies';

export default function Hero() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [searchText, setSearchText] = useState('');

  const nextSlide = useCallback(() => {
    setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
  }, []);

  const prevSlide = useCallback(() => {
    setCurrentSlide((prev) => (prev - 1 + heroSlides.length) % heroSlides.length);
  }, []);

  useEffect(() => {
    const timer = setInterval(nextSlide, 5000);
    return () => clearInterval(timer);
  }, [nextSlide]);

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchText.trim()) {
      window.REACT_APP_NAVIGATE(`/category/movie?search=${encodeURIComponent(searchText.trim())}`);
    }
  };

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden" aria-label="精选推荐">
      {heroSlides.map((slide, index) => (
        <div
          key={slide.id}
          className={`absolute inset-0 transition-opacity duration-700 ${
            index === currentSlide ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <img
            src={slide.bgImage}
            alt={slide.title}
            className="w-full h-full object-cover object-top"
            loading={index === 0 ? 'eager' : undefined}
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
        </div>
      ))}

      <div className="absolute inset-0 flex flex-col items-center justify-center w-full px-4 md:px-6">
        <div className="text-center max-w-2xl w-full">
          <h1 className="font-heading text-3xl md:text-5xl font-bold text-white mb-3 md:mb-4">
            天堂影院
          </h1>
          <p className="text-base md:text-lg text-white/80 mb-6 md:mb-8">
            免费在线看大片 · 高清流畅不缓冲
          </p>

          <form onSubmit={handleSearch} className="flex flex-col sm:flex-row items-center gap-2 max-w-lg mx-auto">
            <div className="relative flex-1 w-full">
              <input
                type="text"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                placeholder="搜索电影、电视剧、综艺、动漫..."
                className="w-full px-4 py-3 pl-10 rounded-full bg-white/95 text-foreground-950 text-sm placeholder:text-foreground-400 outline-none focus:ring-2 focus:ring-primary-400 transition-shadow"
              />
              <i className="ri-search-line absolute left-3.5 top-1/2 -translate-y-1/2 text-foreground-400 text-base"></i>
            </div>
            <button
              type="submit"
              className="w-full sm:w-auto px-6 py-3 bg-primary-500 hover:bg-primary-600 text-white text-sm font-medium rounded-full transition-colors whitespace-nowrap cursor-pointer"
            >
              搜索
            </button>
          </form>
        </div>
      </div>

      <button
        onClick={prevSlide}
        className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-white/20 hover:bg-white/30 text-white transition-colors cursor-pointer"
        aria-label="上一张"
      >
        <i className="ri-arrow-left-s-line text-lg md:text-xl"></i>
      </button>
      <button
        onClick={nextSlide}
        className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-white/20 hover:bg-white/30 text-white transition-colors cursor-pointer"
        aria-label="下一张"
      >
        <i className="ri-arrow-right-s-line text-lg md:text-xl"></i>
      </button>

      <div className="absolute bottom-4 md:bottom-6 left-1/2 -translate-x-1/2 flex items-center gap-2">
        {heroSlides.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentSlide(index)}
            className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
              index === currentSlide ? 'bg-white w-6' : 'bg-white/50 hover:bg-white/70'
            }`}
            aria-label={`切换到第${index + 1}张`}
          ></button>
        ))}
      </div>
    </section>
  );
}